import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const ActionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${SPACING.SMALL_3};

    &.ab-scalable-product-card-isSmartphone {
        display: grid;
        grid-template-columns: 2fr 1fr;
    }
`;

export const LimitedAvailabilityWarning = styled.div`
    display: flex;
    align-items: center;
    grid-column: 1 / -1;
    gap: ${SPACING.SMALL_2};
`;

export const SoldOut = styled.div`
    color: ${Colors.error};
    text-align: center;
    border: 1px solid ${Colors.error};
    padding: ${SPACING.SMALL_3};
`;
